import { AgGridFooterActions } from "@/pages/eaf/data-entry/components/tables/components/AgGridFooterActions";
import { Box, Divider, Paper } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { useProbeActions } from "./hooks/useProbeActions";
import { IProbeRow, useProbesTableData } from "./hooks/useProbesTableData";
import { UpsertDeleteProbeModal } from "./modals/UpsertDeleteProbeModal";

interface Props {
	refreshData: Function;
}

export const ProbesTable = ({ refreshData }: Props) => {
	const classes = useTableStyles();
	const { state, actions } = useCastersContext();
	const processData = state.processData;

	const [modalMode, setModalMode] = useState<"create" | "edit" | "delete" | "">(
		"",
	);
	const [probeSelected, setProbeSelected] = useState<IProbeRow | null>(null);

	const {
		onCreateButtonClick,
		onDeleteButtonClick,
		onDownloadButtonClick,
		onEditButtonClick,
		readProbesFromPLC,
	} = useProbeActions({
		refreshData,
		setProbeSelected,
		setModalMode,
	});

	const { columns, defaultColDef, rowData } = useProbesTableData({
		processData,
		onEditButtonClick,
		onDeleteButtonClick,
		onDownloadButtonClick,
	});

	return (
		<>
			<Paper className={classes.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div
						className={`${classes.materialTable}`}
						style={{ height: "16.1rem" }}
					>
						<AgGridReact
							rowSelection="single"
							suppressRowClickSelection={true}
							pagination={false}
							singleClickEdit={false}
							tooltipShowDelay={0}
							tooltipHideDelay={2000}
							rowData={rowData}
							columnDefs={columns}
							domLayout="normal"
							getRowId={(params) => params.data.id}
						/>
					</div>
					<Divider />
					<AgGridFooterActions
						hasMaxItems={false}
						showCreateModal={modalMode === "create"}
						readFromPLC={readProbesFromPLC}
						setShowCreateModal={onCreateButtonClick}
						table="probes"
					/>
				</Box>
			</Paper>

			{modalMode !== "" && state.processData?.LadleOpen && (
				<UpsertDeleteProbeModal
					show={true}
					onHide={(shouldUpdate: boolean) => {
						if (shouldUpdate) {
							refreshData();
						}
						actions.setRefreshInPause(false);
						setModalMode("");
						setProbeSelected(null);
					}}
					row={probeSelected}
					mode={modalMode}
					limitDates={{
						start: state.processData?.LadleOpen,
						end: state.processData?.LadleClose || null,
					}}
				/>
			)}
		</>
	);
};
